import React, { useState } from "react";
import SanitizeHtml from "../SanitizeHtml/SanitizeHtml";
import orcid from "../assets/orcidIcon.png";

// Assuming SanitizeHtml, orcid image, and AuthorModal are imported above

const TableCellRender = ({
  rowData,
  headerDetails,
  showFullList,
  handleOpenModal,
  handleShowMore,
  handleShowLess,
  handleClick,
}) => {
  const [showAllFunder, setShowAllFunder] = useState(false);
  const [showAllFunderId, setShowAllFunderId] = useState(false);
  const value = rowData[headerDetails.field];

  const renderDoi = () => (
    <a
      href={value}
      target="_blank"
      rel="noreferrer"
      className={value ? "linkText text-nowrap" : "text-secondary flex-box"}
    >
      <span className="text-break text-break-sm">{value}</span>
    </a>
  );

  const renderAuthors = () => {
    const authors = rowData.authorsList || [];
    const totalAuthors = authors.length;

    const limit = showFullList ? totalAuthors : 3;
    const visibleAuthors = authors.slice(0, limit);

    return (
      <div className="flex-box">
        <span onClick={handleOpenModal}>
          {visibleAuthors.map((author, index) => (
            <span key={index}>
              {author.orcid && (
                <a
                  href={author.orcid}
                  target="_blank"
                  rel="noreferrer"
                  className="cursor-pointer"
                  onClick={(e) => e.stopPropagation()} // Prevents triggering modal when clicking ORCID
                >
                  <img
                    height="15px"
                    className="me-1 my-1 text-muted"
                    src={orcid}
                    alt="Author id logo"
                  />
                </a>
              )}
              {author.name}

              {index < visibleAuthors.length - 1 ? ", " : ""}
            </span>
          ))}

          {!showFullList && totalAuthors > 3 && (
            <span
              className=" cursor-pointer ms-1 show-hide-calss"
              onClick={(e) => {
                e.stopPropagation();
                handleShowMore(rowData);
              }}
            >
              {`+ ${totalAuthors - 3} more`}
            </span>
          )}

          {/* Show Less Button */}
          {showFullList && totalAuthors > 3 && (
            <span
              className="cursor-pointer ms-1 show-hide-calss"
              onClick={(e) => {
                e.stopPropagation();
                handleShowLess(rowData);
              }}
            >
              Show Less
            </span>
          )}
        </span>
      </div>
    );
  };

  // 3. Helper Function: Render Standard URLs
  const renderUrl = () => {
    // 1. Safety check for null or undefined
    if (!value) return null;

    // Define your max width
    const MAX_WIDTH = "150px";

    // 2. Check if the value is an array
    if (Array.isArray(value)) {
      return (
        <div className="d-flex flex-column">
          {value.map((url, index) => (
            <a
              key={index}
              target="_blank"
              rel="noreferrer"
              href={url}
              // d-inline-block makes it respect the width, text-break forces the wrap
              className="linkText mb-1 d-inline-block text-nowrap"
              // style={{ maxWidth: MAX_WIDTH }}
            >
              <span>{url}</span>
            </a>
          ))}
        </div>
      );
    }

    // 3. Fallback for a standard single string
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={value}
        // d-inline-block makes it respect the width, text-break forces the wrap
        className="linkText d-inline-block text-break"
        style={{ maxWidth: MAX_WIDTH }}
      >
        <span>{value}</span>
      </a>
    );
  };

  const renderRetracted = () => {
    return (
      <a
        target="_blank"
        rel="noreferrer"
        href={value.retractionDOI}
        // d-inline-block makes it respect the width, text-break forces the wrap
        className="linkText d-inline-block text-break"
      >
        <span>{value.retracted}</span>
      </a>
    );
  };

  const renderCsv = () => {
    // 1. Split and clean the list
    const funderIds = value
      ? value
          .split(/(?<!&)#/)
          .map((id) => id.trim())
          .filter(Boolean)
      : [];

    // If every value is just a placeholder "-", render nothing
    if (funderIds.length === 0 || funderIds.every((id) => id === "-")) {
      return null;
    }

    // 2. Logic for limits (exclude "-" placeholders, they don't render)
    const initialLimit = 3;
    const validItems = funderIds.filter((id) => id !== "-");
    const validCount = validItems.length;
    const hasMore = validCount > initialLimit;
    const remainingCount = validCount - initialLimit;

    // 3. Count of rendered (non "-") items, used to apply the limit
    let renderedCount = 0;

    return (
      <div className="d-flex flex-column text-start">
        {funderIds.map((cleanId, index) => {
          // Extract query ID (handle ROR paths or raw IDs)
          // const queryId = cleanId.includes("/")
          //   ? cleanId.split("/")[1]
          //   : cleanId;

          const queryId = cleanId.includes("http")
            ? cleanId
            : cleanId.includes("/")
              ? cleanId.split("/").pop()
              : cleanId;

          // console.log("visibleIds =>", visibleIds, cleanId, queryId);

          if (cleanId === "-") {
            return null; // Skip rendering for placeholder values
          }

          // Show only the first `initialLimit` valid items unless expanded
          if (!showAllFunderId && renderedCount >= initialLimit) {
            return null;
          }
          renderedCount++;

          return (
            <div key={index} className="mb-1">
              <span className="me-1">{index + 1}.</span>
              <a
                href={
                  queryId.startsWith("http")
                    ? queryId
                    : `https://ror.org/search?query=${queryId}`
                }
                target="_blank"
                rel="noreferrer"
                className="linkText"
              >
                {cleanId}
              </a>
            </div>
          );
        })}

        {/* 4. Toggle Link */}
        {hasMore && (
          <span
            className="cursor-pointer ms-1 show-hide-calss"
            onClick={() => setShowAllFunderId(!showAllFunderId)}
          >
            {showAllFunderId ? "Show less" : `+${remainingCount} more`}
          </span>
        )}
      </div>
    );
  };
  // const renderCsv = () => {
  //   const funderIds = value.split(",");

  //   return (
  //     <div className="d-flex flex-column text-start">
  //       {funderIds.map((id, index) => {
  //         const cleanId = id.trim();

  //         const queryId = cleanId.includes("/")
  //           ? cleanId.split("/")[1]
  //           : cleanId;

  //         return (
  //           <div key={index} className="mb-1">
  //             <span className="me-1">{index + 1}.</span>
  //             <a
  //               href={`https://ror.org/search?query=${queryId}`}
  //               target="_blank"
  //               rel="noreferrer"
  //               className="linkText "
  //             >
  //               {cleanId}
  //             </a>
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // };

  const renderFunder = () => {
    // const funders = value.split(",");
    const funders = value
      ? value
          .split(/(?<!&)#/)
          .map((item) => item.trim())
          .filter(Boolean)
      : [];

    // 2. Define the limit
    const initialLimit = 3; // Show 1 by default, toggle the rest
    const hasMore = funders.length > initialLimit;
    const remainingCount = funders.length - initialLimit;

    // 3. Determine visible items
    const visibleFunders = showAllFunder
      ? funders
      : funders.slice(0, initialLimit);

    return (
      <div className="d-flex flex-column text-start">
        {visibleFunders.map((cleanItem, index) => (
          <div key={index} className="mb-1">
            <span className="me-1">{index + 1}.</span>
            {/* <span>{cleanItem}</span> */}
            <span>{<SanitizeHtml filterText={cleanItem} /> || ""}</span>
          </div>
        ))}

        {/* 4. Toggle Button */}
        {hasMore && (
          <span
            className="cursor-pointer ms-1 show-hide-calss"
            onClick={() => setShowAllFunder(!showAllFunder)}
            // style={{ fontSize: "0.85rem", textDecoration: "none" }}
          >
            {showAllFunder ? "Show less" : `+${remainingCount} more`}
          </span>
        )}
      </div>
    );
  };

  const renderArray = () => {
    return (
      <div className="d-flex flex-column text-start">
        {value.map((item, index) => {
          const cleanItem = item.trim();

          return (
            <div key={index} className="mb-1">
              <span className="me-1">{index + 1}.</span>
              <span className="">{cleanItem}</span>
            </div>
          );
        })}
      </div>
    );
  };

  // 4. Helper Function: Render Default (Text, Numbers, Percentages)
  const renderDefault = () => {
    const formattedValue =
      headerDetails?.dataType === "percentage"
        ? `${value}%`
        : value?.toLocaleString("en-US");

    return (
      <span
        className={headerDetails?.clickable ? "cursor-pointer" : ""}
        onClick={() =>
          headerDetails?.clickable && handleClick(rowData, headerDetails.field)
        }
      >
        {formattedValue ? <SanitizeHtml filterText={formattedValue} /> : ""}
      </span>
    );
  };

  // 5. The Switchboard: Decides which helper to use
  const renderCellContent = () => {
    // if (headerDetails.dataType === "url" && headerDetails.field === "doi") {
    //   return renderDoi();
    // }
    if (headerDetails.field === "authors") {
      return renderAuthors();
    }
    if (headerDetails.dataType === "url") {
      return renderUrl();
    }
    if (headerDetails.field === "retracted") {
      return renderRetracted();
    }
    if (
      headerDetails.dataType === "csv" &&
      (headerDetails.field === "funderIds" ||
        headerDetails.field === "funderRorIds")
    ) {
      return renderCsv();
    }
    if (headerDetails.field === "funders") {
      return renderFunder();
    }
    if (headerDetails.dataType === "array") {
      return renderArray();
    }

    return renderDefault();
  };

  // 6. Main Render
  return <>{renderCellContent()}</>;
};

export default TableCellRender;
